/**
 * 数据类型
 */
export enum DataType {
    list = 1,
    group = 2
}
